import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/system/dict',
    component: Layout,
    redirect: '/system/dict/index',
    meta: {
      title: '字典管理',
      keepAlive: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'index',
        name: 'SystemDictIndex',
        component: () => import('@/views/system/dict/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '字典管理'
        }
      }
    ]
  }
]

export default router
